import React from 'react';
import { X } from 'lucide-react';

const DeleteEventDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  eventType, // 'single', 'recurring', 'recurringInstance'
  eventTitle 
}) => {
  if (!isOpen) return null;

  const handleChoice = (choice) => {
    onConfirm(choice);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4">
      <div className="bg-background rounded-lg p-6 max-w-md w-full border border-border">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-lg font-semibold">Delete Event</h3>
          <button 
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground p-1"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        
        <p className="text-muted-foreground mb-6">
          {eventType === 'recurring' && (
            <>
              <span className="font-medium">"{eventTitle}"</span> is a recurring event. 
              Do you want to delete all instances or just the parent event?
            </>
          )}
          {eventType === 'recurringInstance' && (
            <>
              <span className="font-medium">"{eventTitle}"</span> is part of a recurring series. 
              What would you like to delete?
            </>
          )}
          {eventType === 'single' && (
            <>
              Are you sure you want to delete <span className="font-medium">"{eventTitle}"</span>?
            </>
          )}
        </p>
        
        <div className="flex gap-2 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-border rounded-md hover:bg-muted transition-colors"
          >
            Cancel
          </button>
          
          {eventType === 'single' ? (
            <button
              onClick={() => handleChoice('single')}
              className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
            >
              Delete
            </button>
          ) : (
            <>
              <button
                onClick={() => handleChoice('single')}
                className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors"
              >
                This Event Only
              </button>
              <button
                onClick={() => handleChoice('all')}
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
              >
                {eventType === 'recurring' ? 'All Instances' : 'All Future Events'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteEventDialog;